import { hexToRGB } from '@capsicum/common';
import styled from 'styled-components';

export const ButtonSection = styled.div<{ $alwaysFixedPosition?: boolean; $stackButtonsVertically?: boolean }>`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: ${({ theme }) => theme.spacings.xlarge};

	${({ $stackButtonsVertically, theme }) =>
		$stackButtonsVertically
			? `
		flex-direction: column;
		gap: ${theme.spacings.xxsmall};
		`
			: ''}

	${({ $alwaysFixedPosition, theme }) =>
		$alwaysFixedPosition ? '&:is(*)' : theme.breakpoints.queries.below.tabletSmallDesktop} {
		position: fixed;
		border-top-style: solid;
		right: 0;
		bottom: 0;
		background-color: ${({ theme }) => hexToRGB(theme.colors.backgrounds.main.container, 0.92)};
		border-top-width: 1px;
		border-top-color: ${({ theme }) => theme.colors.borders.main.divider};
		padding: ${({ theme }) => theme.spacings.xsmall} ${({ theme }) => theme.spacings.small};
		margin-top: 0;
	}
`;
